/*
 * pep-variant-pills.js
 * ---------------------------------------------------------------------------
 * Progressive enhancement for the product-page variant options: renders the
 * option values (already output as pill buttons in main-product.liquid) as an
 * interactive segmented control that DRIVES the theme's native <select>.
 *
 * We keep the <select data-option-selector> in the DOM and, on pill click,
 * set its value + dispatch a 'change' event — so global.js's initProductForm
 * (price / availability / add-to-cart state) keeps working unchanged.
 *
 * Also greys out option values that can't form an AVAILABLE variant with the
 * currently-selected other options, recomputed on every change.
 */
(function () {
  function init(root) {
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;
    var dataEl = root.querySelector('[data-variant-json]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-variant-option]'));
    if (!groups.length) return;
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-selector]'));

    function chosen() { return selects.map(function (s) { return s.value; }); }

    // Grey out values that have no available variant given the other current choices.
    function refreshAvailability() {
      if (!variants.length) return;
      var cur = chosen();
      groups.forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-variant-option-index'), 10);
        var pills = group.querySelectorAll('[data-option-pill]');
        Array.prototype.forEach.call(pills, function (pill) {
          var val = pill.getAttribute('data-value');
          var ok = variants.some(function (v) {
            if (v.options[pos] !== val) return false;
            for (var i = 0; i < v.options.length; i++) {
              if (i !== pos && v.options[i] !== cur[i]) return false;
            }
            return v.available;
          });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function selectPill(pill) {
      var group = pill.closest('[data-variant-option]');
      if (!group) return;
      var pills = group.querySelectorAll('[data-option-pill]');
      Array.prototype.forEach.call(pills, function (p) {
        var on = (p === pill);
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var sel = group.querySelector('[data-option-selector]');
      var val = pill.getAttribute('data-value');
      if (sel) {
        sel.value = val;
        sel.dispatchEvent(new Event('change', { bubbles: true })); // -> initProductForm.update()
      }
      var label = group.querySelector('[data-option-selected]');
      if (label) label.textContent = val;
      refreshAvailability();
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-option-pill]');
      if (pill && root.contains(pill)) { e.preventDefault(); selectPill(pill); }
    });

    // Keyboard: arrow keys move within a radiogroup.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var pill = e.target.closest('[data-option-pill]');
      if (!pill) return;
      var group = pill.closest('[data-variant-option]');
      var pills = Array.prototype.slice.call(group.querySelectorAll('[data-option-pill]'));
      var idx = pills.indexOf(pill);
      var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? idx + 1 : idx - 1;
      if (next < 0) next = pills.length - 1;
      if (next >= pills.length) next = 0;
      e.preventDefault();
      pills[next].focus();
      selectPill(pills[next]);
    });

    refreshAvailability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
